import { ProgressCallback } from "../types/ProgressTypes";
import { doesSheetExist, handleExistingSheetInsertionData, handleNewSheetInsertionData } from "../wrappers/common";
import { formatWasteProcessSheet, WasteProcessData } from "@carbowaste/excel-sheets-generator/dist/sheets/dictionaries/dictionaries_wasteprocess";
import { formatWasteCodeSheet, WasteCodeData } from "@carbowaste/excel-sheets-generator/dist/sheets/dictionaries/dictionaries_wastecode";
import { dictionaryClient } from "../../services/ApiClients";

export class DictionaryDataFetchWrapper {

    static wrapDictionaryWasteProcessDataFetch(
        sheetName: string,
        isTrial?: boolean | null
    ) {
        return async (callbacks: ProgressCallback) => {
            try {
                callbacks.onProgress?.("Pobieranie danych słownikowych...", 0);

                callbacks.onProgress?.("Pobieranie danych...", 20);

                // Pobieranie danych słownikowych z API
                const data: WasteProcessData[] = await dictionaryClient.getWasteProcessData();

                // Sprawdzenie, czy arkusz już istnieje
                callbacks.onProgress?.("Sprawdzanie istniejącego arkusza...", 40);
                const sheetExists = await doesSheetExist(sheetName);
                if (sheetExists) {
                    callbacks.onProgress?.("Arkusz już istnieje, aktualizacja danych...", 60);
                    await handleExistingSheetInsertionData(sheetName, true);
                } else {
                    callbacks.onProgress?.("Tworzenie nowego arkusza...", 60);
                    await handleNewSheetInsertionData(sheetName, true);
                }

                if (data && data.length > 0) {
                    // Wstawianie wartości do arkusza
                    await formatWasteProcessSheet(sheetName, data, isTrial);
                    callbacks.onProgress?.("Finalizowanie...", 100);
                    callbacks.onSuccess?.("Dane słownikowe pobrane pomyślnie!");
                } else {
                    throw new Error("Błąd podczas pobierania danych słownikowych.");
                }

            } catch (error) {
                callbacks.onError?.(error instanceof Error ? error.message : "Wystąpił błąd podczas pobierania danych słownikowych");
            }
        };
    }

    static wrapDictionaryWasteCodeDataFetch(
        sheetName: string,
        isTrial?: boolean | null
    ) {
        return async (callbacks: ProgressCallback) => {
            try {
                callbacks.onProgress?.("Pobieranie danych słownikowych...", 0);

                callbacks.onProgress?.("Pobieranie danych...", 20);
                // Pobieranie danych słownikowych z API
                const data: WasteCodeData[] = await dictionaryClient.getAllWasteCodeData();

                // Sprawdzenie, czy arkusz już istnieje
                callbacks.onProgress?.("Sprawdzanie istniejącego arkusza...", 40);
                const sheetExists = await doesSheetExist(sheetName);
                if (sheetExists) {
                    callbacks.onProgress?.("Arkusz już istnieje, aktualizacja danych...", 60);
                    await handleExistingSheetInsertionData(sheetName, true);
                } else {
                    callbacks.onProgress?.("Tworzenie nowego arkusza...", 60);
                    await handleNewSheetInsertionData(sheetName, true);
                }

                if (data && data.length > 0) {
                    // Wstawianie wartości do arkusza
                    await formatWasteCodeSheet(sheetName, data, isTrial);
                    callbacks.onProgress?.("Finalizowanie...", 100);
                    callbacks.onSuccess?.("Dane słownikowe pobrane pomyślnie!");

                } else {
                    throw new Error("Błąd podczas pobierania danych słownikowych.");
                }


            } catch (error) {
                callbacks.onError?.(error instanceof Error ? error.message : "Wystąpił błąd podczas pobierania danych słownikowych");
            }
        };
    }
}